// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreCartSync = (client) => ({
    /**
     * `POST /store/cart-sync`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCartSyncCreate
     * @source apps/backend/src/api/store/cart-sync/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/cart-sync", { method: "POST", body, query, headers }),
    /**
     * `GET /store/cart-sync`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCartSyncList
     * @source apps/backend/src/api/store/cart-sync/route.ts
     */
    list: (query, headers) => client.fetch("/store/cart-sync", { method: "GET", query, headers }),
});
//# sourceMappingURL=cart-sync.js.map